import { useState } from 'react';
import {
  useUserManagementAPI,
  UseUserManagementAPIReturn,
} from 'src/SharedCustomHooks/UseUserManagementAPI/useUserManagementAPI';
import {
  useChangeEmailFormState,
  UseChangeEmailFormStateReturn,
} from 'src/components/ContactFormComponents/ChangeUserEmailDialogue/CustomHooks/useChangeEmailFormState';
import { ChangeEmailViewModel } from 'src/components/ChangeEmailDialogue/changeEmailViewModel';

export interface UseChangeUserEmailOrchestratorArgs {
  contactId: string;
  currentEmail: string;
  onSuccess?: () => void;
}

export const useChangeUserEmailOrchestrator = ({
  contactId,
  currentEmail,
  onSuccess,
}: UseChangeUserEmailOrchestratorArgs): ChangeEmailViewModel => {
  const userManagementAPI: UseUserManagementAPIReturn = useUserManagementAPI();

  const formState: UseChangeEmailFormStateReturn =
    useChangeEmailFormState(currentEmail);

  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const reset = () => {
    setIsSuccess(false);
    formState.reset();
    userManagementAPI.clearError();
    userManagementAPI.clearSuccess();
  };

  const submit = async (): Promise<void> => {
    if (!formState.isValid) {
      return;
    }

    const ok: boolean = await userManagementAPI.changeUserEmail({
      userId: contactId,
      newEmail: formState.email.trim(),
    });

    if (!ok) {
      return;
    }

    // Hold the entered email so the dialog can show the confirmation screen; the form clears on close.
    setIsSuccess(true);
    onSuccess?.();
  };

  return {
    currentEmail,
    newEmail: formState.email,
    setNewEmail: formState.setEmail,
    error: userManagementAPI.error,
    isSubmitting: userManagementAPI.isSubmitting,
    isSuccess,
    canSubmit: formState.isValid,
    submit: () => {
      void submit();
    },
    reset,
  };
};
